import * as React from 'react';
import { Drawer as DrawerPrimitive } from 'vaul';
import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const drawerDescriptionVariants = cva('rocco-drawer-description', {
    variants: {
        variant: {
            default: 'text-sm text-muted-foreground',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const DrawerDescription = React.forwardRef<
    React.ElementRef<typeof DrawerPrimitive.Description>,
    React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Description> &
        VariantProps<typeof drawerDescriptionVariants>
>(({ className, variant, ...props }, ref) => (
    <DrawerPrimitive.Description
        ref={ref}
        className={cn(drawerDescriptionVariants({ variant, className }))}
        {...props}
    />
));

DrawerDescription.displayName = DrawerPrimitive.Description.displayName;
